import { render, staticRenderFns } from "./information-du-contrat.vue?vue&type=template&id=beda69ac"
import script from "./information-du-contrat.vue?vue&type=script&lang=ts"
export * from "./information-du-contrat.vue?vue&type=script&lang=ts"
import style0 from "./information-du-contrat.vue?vue&type=style&index=0&id=beda69ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports